import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {TouchableOpacity, Text, StyleProp} from 'react-native';
import styleSheet from './styles';

export interface LongRectangleTextButtonProps {
  onPress: () => void;
  title: string;
  backgroundColor?: string;
  buttonStyle?: object;
  titleColor?: object;
  disabled?: boolean;
}

const LongRectangleTextButton = (props: LongRectangleTextButtonProps) => {
  const styles = styleSheet(useTheme());

  return (
    <TouchableOpacity
      style={[
        styles.container,
        {
          ...(props.backgroundColor && {
            backgroundColor: props.backgroundColor,
          }),
        },
        props.buttonStyle,
      ]}
      onPress={props.onPress}
      disabled={props.disabled}>
      <Text style={[styles.textStyle, props.titleColor]}>{props.title}</Text>
    </TouchableOpacity>
  );
};

export default LongRectangleTextButton;
